module.exports = __webpack_public_path__ + "img/globe_example.f6bf8ec3.svg";